import { defineAction } from '~/prix'
import { z } from 'zod'
import materialDeliveryImageCreateAction from './materialDeliveryImageCreate.action.json' with { type: 'json' }
import { acceptedFormat, materialDeliveryImageObject } from '../materialDeliveryImageObject'

const materialDeliveryImageCreateDefinition = defineAction({
  ...materialDeliveryImageCreateAction,
  input: materialDeliveryImageObject
    .pick({
      id: true,
      materialDeliveryId: true,
      description: true,
      position: true,
    })
    .partial({ id: true, description: true, position: true })
    .extend({
      format: acceptedFormat,
    }),
  output: z.object({
    publicUrl: z.string().nullish(),
    uploadUrl: z.string().nullish(),
  }),
})

export default materialDeliveryImageCreateDefinition
